"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditLineModel = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_validator_1 = require("class-validator");
class CreditLineModel {
}
exports.CreditLineModel = CreditLineModel;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], CreditLineModel.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.CreditLinePartnerType),
    __metadata("design:type", Number)
], CreditLineModel.prototype, "partnerType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreditLineModel.prototype, "partnerId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLineModel.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    __metadata("design:type", Number)
], CreditLineModel.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.CreditLinePeriodUnit),
    __metadata("design:type", Number)
], CreditLineModel.prototype, "periodUnit", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], CreditLineModel.prototype, "periodLength", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], CreditLineModel.prototype, "firstPeriodStart", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.Min)(1, { each: true }),
    (0, class_validator_1.Max)(100, { each: true }),
    __metadata("design:type", Array)
], CreditLineModel.prototype, "warningThresholds", void 0);
//# sourceMappingURL=credit-line.model.js.map